import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { useCart } from '../contexts/CartContext';
export function CartButton() {
  const {
    totalItems,
    openCart
  } = useCart();
  return <motion.button onClick={openCart} className="relative p-3 hover:bg-gray-100 rounded-full transition-colors" whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} aria-label={`Open cart with ${totalItems} items`} data-id="element-6">
      <ShoppingCartIcon className="w-6 h-6 text-gray-900" data-id="element-7" />

      {/* Item Count Badge */}
      {totalItems > 0 && <motion.span initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} className="absolute -top-1 -right-1 bg-brand-red text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center" data-id="element-8">
          {totalItems}
        </motion.span>}
    </motion.button>;
}